import "core-js/modules/es.array.includes.js";
import styled, { css } from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1mepuru-0"
})(["display:", ";", ";"], function (_ref) {
  var _ref$display = _ref.display,
    display = _ref$display === void 0 ? 'block' : _ref$display;
  return display;
}, function (_ref2) {
  var display = _ref2.display;
  return ['flex', 'inline-flex'].includes(display) && css(["> div{&:not(:first-child){margin-left:12px;}}"]);
});